import { createContext, useContext } from 'react';
import { THEME_PRESETS } from '@/lib/theme-presets';

export interface ThemeSettings {
  theme_name: string;
  primary_color: string | null;
  button_text_color: string | null;
  button_style: string;
  heading_font: string;
  body_font: string;
  layout_style: string;
}

export const ThemeContext = createContext<ThemeSettings | null>(null);

export const useTheme = () => useContext(ThemeContext);
export const useLayoutStyle = () => useContext(ThemeContext)?.layout_style || 'classic';

/** The layout composition the site wears — the active preset id (unknown/none → classic). */
export const useThemeVariant = (): string => {
  const name = useContext(ThemeContext)?.theme_name;
  return THEME_PRESETS.some((p) => p.id === name) ? (name as string) : 'classic';
};
